import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=17aae536&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=17aae536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aae536",
  null
  
)

export default component.exports